export default __webpack_public_path__ + "static/media/chevron-down.cf5ddc18.svg";